import { Plugin } from 'ckeditor5';

class AutoLinker extends Plugin {
  init() {
    const editor = this.editor;

    editor.model.document.on('change:data', () => {
      const model = editor.model;
      const root = model.document.getRoot();

      if (root === null) {
        return;
      }

      setTimeout(() => {
        model.change((writer) => {
          const range = writer.createRangeIn(root);
          const walker = range.getWalker({ ignoreElementEnd: true });
          //@ts-ignore
          for (const { item } of walker) {
            if (item && item.is && typeof item.is === 'function' && item.is('textProxy')) {
              const urlRegex = /(https?:\/\/[^\s]+)/g;
              const matches = [...item.data.matchAll(urlRegex)];

              matches.forEach((match) => {
                const startOffset = item.startOffset + (match.index || 0);
                const endOffset = startOffset + match[0].length;

                const range = writer.createRange(
                  writer.createPositionAt(item.parent, startOffset),
                  writer.createPositionAt(item.parent, endOffset)
                );

                writer.setAttribute('linkHref', match[0], range);
              });
            }
          }
        });
      }, 50);
    });
  }
}

export default AutoLinker;
